import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const visiblePages = 5;
  const pageNumbers = [];

  let startPage = Math.max(2, currentPage - Math.floor(visiblePages / 2));
  let endPage = Math.min(totalPages - 1, currentPage + Math.floor(visiblePages / 2));

  if (currentPage <= 3) {
    startPage = 2;
    endPage = Math.min(visiblePages, totalPages - 1);
  }

  if (currentPage >= totalPages - 2) {
    endPage = totalPages - 1;
    startPage = Math.max(2, totalPages - visiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handleSelectChange = (e) => {
    const page = parseInt(e.target.value, 10);
    if (!isNaN(page)) onPageChange(page);
  };

  return (
    <div style={styles.wrapper}>
      <nav style={styles.container}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            ...styles.navBtn,
            opacity: currentPage === 1 ? 0.6 : 1,
          }}
        >
          ◀ Prev
        </button>

        {/* First Page */}
        <button
          onClick={() => onPageChange(1)}
          style={{
            ...styles.pageBtn,
            ...(currentPage === 1 ? styles.active : {}),
          }}
        >
          1
        </button>

        {/* Left Ellipsis */}
        {startPage > 2 && <span style={styles.ellipsis}>...</span>}

        {/* Middle Pages */}
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            style={{
              ...styles.pageBtn,
              ...(currentPage === page ? styles.active : {}),
            }}
          >
            {page}
          </button>
        ))}

        {/* Right Ellipsis */}
        {endPage < totalPages - 1 && <span style={styles.ellipsis}>...</span>}

        {/* Last Page */}
        {totalPages > 1 && (
          <button
            onClick={() => onPageChange(totalPages)}
            style={{
              ...styles.pageBtn,
              ...(currentPage === totalPages ? styles.active : {}),
            }}
          >
            {totalPages}
          </button>
        )}

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            ...styles.navBtn,
            opacity: currentPage === totalPages ? 0.6 : 1,
          }}
        >
          Next ▶
        </button>
      </nav>

      {/* Go To Page Dropdown - New Line */}
      {totalPages > 1 && (
        <div style={styles.dropdownWrapper}>
          <label htmlFor="goToPage" style={styles.label}>Go to Page</label>
          <select
            id="goToPage"
            value={currentPage}
            onChange={handleSelectChange}
            style={styles.select}
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <option key={page} value={page}>
                {page}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: {
    marginTop: '30px',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
  },
  pageBtn: {
    padding: '8px 14px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    backgroundColor: '#f0f0f0',
    color: '#000',
    cursor: 'pointer',
  },
  navBtn: {
    padding: '8px 14px',
    fontSize: '15px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: '#0d6efd',
    color: '#fff',
    cursor: 'pointer',
  },
  active: {
    backgroundColor: '#0d6efd',
    color: '#fff',
    fontWeight: 'bold',
  },
  ellipsis: {
    padding: '0 6px',
    fontSize: '18px',
    userSelect: 'none',
  },
  dropdownWrapper: {
    marginTop: '12px',
    textAlign: 'center',
  },
  label: {
    fontSize: '14px',
    marginRight: '8px',
  },
  select: {
  padding: '6px 10px',
  fontSize: '14px',
  width: '50px', // or '60px' for tighter look
  borderRadius: '5px',
  border: '1px solid #ccc',
}

};

export default Pagination;
